import {
  NOTIFICATION_DELIVERY_STATUS_LABELS,
  type NotificationDeliveryStatus,
} from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { StatusBadge } from '@/shared/ui';
import { NOTIFICATION_STATUS_TONES } from '../model/delivery-status-tone';

interface NotificationStatusBadgeProps {
  readonly status: NotificationDeliveryStatus;
}

/** 알림 발송 결과 배지 — 이름은 계약 라벨(대기·성공·실패·건너뜀), 색은 결과 톤. */
export const NotificationStatusBadge = ({ status }: NotificationStatusBadgeProps): ReactElement => (
  <StatusBadge tone={NOTIFICATION_STATUS_TONES[status]}>
    {NOTIFICATION_DELIVERY_STATUS_LABELS[status]}
  </StatusBadge>
);
